export const SENSE_CHAPTER = 'Sense capítol';

export interface ChapterGroup<T> {
  chapter: string;
  items: { item: T; originalIdx: number }[];
}

export function groupByChapter<T extends { chapter?: string | null }>(
  lines: T[],
): ChapterGroup<T>[] {
  const order: string[] = [];
  const map = new Map<string, { item: T; originalIdx: number }[]>();

  lines.forEach((item, originalIdx) => {
    const key = item.chapter?.trim() || SENSE_CHAPTER;
    if (!map.has(key)) {
      order.push(key);
      map.set(key, []);
    }
    map.get(key)!.push({ item, originalIdx });
  });

  return order.map((chapter) => ({ chapter, items: map.get(chapter)! }));
}
